module.exports = __webpack_public_path__ + "img/Oskar Antonik.1b8baa27.webp";